// Cart Drawer Toggle
document.addEventListener("DOMContentLoaded", () => {
  const cartToggle = document.querySelector(".cart-toggle")
  const cartDrawer = document.querySelector(".cart-drawer")
  const cartClose = document.querySelector(".cart-drawer-close")

  if (cartToggle) {
    cartToggle.addEventListener("click", () => {
      cartDrawer.classList.add("active")
    })
  }

  if (cartClose) {
    cartClose.addEventListener("click", () => {
      cartDrawer.classList.remove("active")
    })
  }

  // Close cart when clicking outside
  document.addEventListener("click", (event) => {
    if (
      cartDrawer.classList.contains("active") &&
      !cartDrawer.contains(event.target) &&
      !cartToggle.contains(event.target)
    ) {
      cartDrawer.classList.remove("active")
    }
  })

  // Cart quantity update
  const quantityBtns = document.querySelectorAll(".quantity-btn")
  quantityBtns.forEach((btn) => {
    btn.addEventListener("click", function () {
      const action = this.dataset.action
      const key = this.dataset.key
      const input = this.parentElement.querySelector(".quantity-input")
      let quantity = Number.parseInt(input.value)

      if (action === "increase") {
        quantity++
      } else if (action === "decrease" && quantity > 1) {
        quantity--
      }

      updateCartItem(key, quantity)
    })
  })

  // Remove item
  const removeButtons = document.querySelectorAll(".remove-item")
  removeButtons.forEach((btn) => {
    btn.addEventListener("click", function () {
      const key = this.dataset.key
      updateCartItem(key, 0)
    })
  })

  // Product image thumbnails
  const thumbnails = document.querySelectorAll(".thumbnail")
  const mainImage = document.getElementById("ProductMainImage")

  thumbnails.forEach((thumb) => {
    thumb.addEventListener("click", function () {
      const imageUrl = this.dataset.image
      if (mainImage) {
        mainImage.src = imageUrl
      }

      thumbnails.forEach((t) => t.classList.remove("active"))
      this.classList.add("active")
    })
  })

  // Add to cart form
  const addToCartForm = document.getElementById("AddToCartForm")
  if (addToCartForm) {
    addToCartForm.addEventListener("submit", function (e) {
      e.preventDefault()

      const formData = new FormData(this)

      fetch("/cart/add.js", {
        method: "POST",
        body: formData,
      })
        .then((response) => response.json())
        .then((data) => {
          // Update cart count
          updateCartCount()
          // Open cart drawer
          cartDrawer.classList.add("active")
          // Reload cart contents
          location.reload()
        })
        .catch((error) => {
          console.error("Error:", error)
        })
    })
  }

  // Collection sorting
  const sortSelect = document.getElementById("SortBy")
  if (sortSelect) {
    sortSelect.addEventListener("change", function () {
      const value = this.value
      const url = new URL(window.location.href)
      url.searchParams.set("sort_by", value)
      window.location.href = url.toString()
    })
  }
})

// Update cart item quantity
function updateCartItem(key, quantity) {
  fetch("/cart/change.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      id: key,
      quantity: quantity,
    }),
  })
    .then((response) => response.json())
    .then((data) => {
      location.reload()
    })
    .catch((error) => {
      console.error("Error:", error)
    })
}

// Update cart count
function updateCartCount() {
  fetch("/cart.js")
    .then((response) => response.json())
    .then((data) => {
      const cartCount = document.querySelector(".cart-count")
      if (cartCount) {
        cartCount.textContent = data.item_count
      }
    })
}

// Mobile menu toggle
const mobileMenuToggle = document.querySelector(".mobile-menu-toggle")
const headerNav = document.querySelector(".header-nav")

if (mobileMenuToggle) {
  mobileMenuToggle.addEventListener("click", function () {
    headerNav.classList.toggle("active")
    this.classList.toggle("active")
  })
}
